import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';
import { FilterConfigSchema, LimitConfigSchema, SortConfigSchema } from '../utils/filterConfig.js';

export const FilterListBlockConfigSchema = z.object({
  originalList: z.string().min(1),
  filterConfig: FilterConfigSchema.transform((obj) => {
    if (!obj?.filterConditions?.length) {
      return undefined;
    }
    return obj;
  }).optional(),
  sortConfig: SortConfigSchema.transform((obj) => {
    if (!obj?.fieldToSort) {
      return undefined;
    }
    return obj;
  }).optional(),
  limitConfig: LimitConfigSchema.optional(),
});
export type FilterListBlockConfig = z.infer<typeof FilterListBlockConfigSchema>;

export const FilterListBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.FilterList),
  config: FilterListBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.ListOfObjects),
});
export type FilterListBlock = z.infer<typeof FilterListBlockSchema>;
